export const isValidAgentId = (agentId?: number | null): boolean => {
  return typeof agentId === 'number' && agentId > 0;
};
